var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppdevbanner2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 608,
    height: 530,
    viewBox: "0 0 608 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60197 283.162C3.60197 283.162 6.12824 287.934 3.88236 292.425C1.63648 296.915 -1.17019 301.407 0.513541 303.653C2.19727 305.899 7.24982 308.705 6.68903 313.477C6.12688 318.25 -0.609394 327.793 3.60197 333.125C7.81197 338.458 14.83 338.178 15.1104 344.072C15.3908 349.967 8.37412 354.738 10.3382 360.071C12.3037 365.404 23.8108 366.526 23.8108 370.176C23.8108 373.825 19.3204 377.754 22.9683 381.684C26.6175 385.614 44.2716 395.865 46.7979 391.655C49.3241 387.445 54.4065 375.789 51.0621 359.257C50.4999 356.478 46.5473 355.861 45.9851 351.931C45.4243 348.001 47.1081 340.985 44.3014 337.055C41.4947 333.125 32.5126 331.722 31.9504 328.635C31.3896 325.547 35.3179 317.969 31.3896 313.197C27.46 308.425 18.1975 306.18 18.1975 303.092C18.1975 300.005 21.0041 296.075 17.0745 291.864C13.1463 287.654 3.60197 283.162 3.60197 283.162Z",
    fill: "#1B2F6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0449 316.239C22.8872 333.884 33.1264 357.787 37.2836 369.334C42.3361 383.369 46.7276 393.528 48.9735 407.563C51.2194 421.598 52.4412 515.591 52.4412 515.591",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00586 284.847C5.00586 284.847 9.77801 288.777 13.988 305.898C14.2589 307.002 14.5718 308.169 14.92 309.389",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3411 315.142C91.3411 315.142 89.3187 318.961 91.1163 322.556C92.9138 326.149 95.1596 329.744 93.8118 331.541C92.4641 333.337 88.4207 335.584 88.8704 339.402C89.3201 343.221 94.7113 350.858 91.3411 355.126C87.9709 359.395 82.3562 359.17 82.1314 363.886C81.9065 368.604 87.5226 372.423 85.9499 376.69C84.3773 380.958 75.1675 381.856 75.1675 384.777C75.1675 387.697 78.7612 390.842 75.8421 393.986C72.9217 397.132 58.7935 405.336 56.7725 401.966C54.7514 398.596 50.6837 389.268 53.3603 376.038C53.81 373.815 56.9743 373.321 57.4227 370.176C57.8724 367.03 56.5246 361.416 58.7705 358.27C61.0163 355.125 68.205 354.002 68.6548 351.531C69.1045 349.061 65.9592 342.995 69.1045 339.176C72.2498 335.358 79.662 333.56 79.662 331.089C79.662 328.619 77.4161 325.473 80.5601 322.105C83.704 318.736 91.3411 315.142 91.3411 315.142Z",
    fill: "#1B2F6C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5834 341.612C75.9074 355.733 67.7136 374.861 64.3854 384.103C60.342 395.335 56.8269 403.465 55.0294 414.697C53.2319 425.93 52.2539 501.152 52.2539 501.152",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2189 316.49C90.2189 316.49 86.4003 319.635 83.0302 333.338C82.8134 334.221 82.5628 335.155 82.2852 336.133",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.097 378.746C14.097 378.746 15.7862 381.936 14.2853 384.939C12.7845 387.942 10.907 390.945 12.0327 392.446C13.1583 393.948 16.5366 395.824 16.1614 399.014C15.7862 402.204 11.2822 408.585 14.097 412.152C16.9118 415.719 21.6041 415.53 21.7923 419.472C21.9806 423.414 17.2884 426.604 18.6023 430.169C19.9163 433.736 27.6102 434.486 27.6102 436.926C27.6102 439.365 24.6071 441.993 27.0467 444.621C29.4863 447.249 41.29 454.103 42.9792 451.288C44.6683 448.473 48.0669 440.681 45.8305 429.626C45.4553 427.769 42.8112 427.356 42.436 424.728C42.0608 422.1 43.1864 417.408 41.3103 414.781C39.4343 412.153 33.4281 411.215 33.0529 409.152C32.6777 407.087 35.3055 402.02 32.6777 398.83C30.0498 395.64 23.8567 394.138 23.8567 392.073C23.8567 390.009 25.7328 387.381 23.1063 384.566C20.4784 381.749 14.097 378.746 14.097 378.746Z",
    fill: "#1B2F6C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0879 400.861C26.9945 412.66 33.8405 428.641 36.6201 436.362C39.9984 445.746 42.9351 452.538 44.4359 461.923C45.9368 471.307 46.7536 506.137 46.7536 506.137",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0371 379.871C15.0371 379.871 18.2271 382.499 21.0433 393.946C21.2248 394.685 21.4334 395.465 21.6664 396.28",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.767 374.073C110.767 374.073 108.392 376.791 109.167 380.059C109.942 383.326 111.081 386.678 109.641 387.881C108.201 389.085 104.483 390.139 104.119 393.331C103.754 396.522 106.679 403.765 103.122 406.592C99.5647 409.419 95.0404 408.162 93.9554 411.956C92.8704 415.75 96.7079 419.929 94.6137 423.1C92.5195 426.271 84.8567 425.24 84.2973 427.615C83.7392 429.989 86.0609 433.235 83.085 435.234C80.109 437.234 67.0495 441.205 66.0499 438.078C65.0502 434.95 63.5263 426.587 68.2321 416.337C69.0232 414.614 71.6903 414.817 72.6575 412.345C73.6246 409.873 73.6016 405.048 76.0304 402.92C78.4591 400.792 84.5194 401.252 85.3579 399.329C86.1964 397.405 84.7971 391.87 88.086 389.366C91.3736 386.861 97.7468 386.817 98.2196 384.808C98.6923 382.798 97.4664 379.811 100.669 377.672C103.868 375.534 110.767 374.073 110.767 374.073Z",
    fill: "#1B2F6C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9549 393.543C90.4516 404.135 80.1297 418.125 75.6569 425.004C70.2211 433.366 63.7002 438.714 62.1979 448.099C60.6971 457.482 59.8789 492.313 59.8789 492.313",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.597 374.953C109.597 374.953 105.889 376.78 100.529 387.281C100.184 387.958 99.8018 388.67 99.3887 389.41",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.101 526.169H64.9763C75.9605 520.503 83.7628 506.168 83.7628 489.368C83.7628 478.341 80.3994 468.378 74.9838 461.226H34.0948C28.6792 468.378 25.3145 478.341 25.3145 489.368C25.3145 506.168 33.1181 520.503 44.101 526.169Z",
    fill: "#1B2F6C",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3561 526.169H44.1016V529.282H65.3561V526.169Z",
    fill: "#1B2F6C",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M355.045 1H22.3066V252.84H355.045V1Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M347.277 7.67139H30.0742V246.169H347.277V7.67139Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M126.762 42.6748C126.762 42.6748 74.939 38.928 70.5691 47.046C66.1979 55.1626 69.3202 203.763 71.818 205.636C74.3159 207.51 144.246 208.759 151.113 206.261C157.981 203.763 148.615 52.6647 148.615 48.2949C148.615 43.9237 132.382 42.0517 132.382 42.0517",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9219 165.677C76.0248 185.268 76.4515 199.623 77.4336 200.015C80.5559 201.264 146.739 206.883 148.612 200.639C150.486 194.396 143.617 53.2878 143.617 53.2878",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M141.123 52.6647C141.123 52.6647 78.0612 50.1668 77.4367 53.2891C77.0385 55.2776 75.8803 113.787 75.9007 156.311",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3066 63.9021H140.495",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M134.879 61.0762C131.132 65.0329 134.879 61.0762 137.377 55.4236C139.875 49.771 134.879 56.5546 129.26 61.0762C123.642 65.5978 126.762 62.2073 128.636 55.9884C130.509 49.771 126.762 55.9884 121.768 59.9451C116.772 63.9018 119.27 62.2059 121.144 55.4236C123.017 48.6412 121.144 55.4236 113.652 59.9451C106.159 64.4667 109.905 64.4667 113.652 57.6844C117.398 50.902 111.154 57.6844 104.286 59.9451C97.4184 62.2059 104.286 59.9451 106.784 53.7277C109.282 47.5102 102.414 55.4236 97.4184 58.8154C92.4227 62.2073 97.4184 58.8154 98.6673 54.8587C99.9162 50.902 95.545 55.9884 90.5507 61.0762C85.5551 66.164 90.5507 61.0762 91.1752 56.5546C91.7996 52.0331 85.5564 63.9032 85.5564 63.9032C85.5564 63.9032 87.4298 52.5979 86.1809 55.4249C84.932 58.2506 83.0586 60.5127 83.0586 60.5127",
    stroke: "#1B2F6C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M113.024 74.5168H82.4297V106.36H113.024V74.5168Z",
    stroke: "#1B2F6C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6729 74.5168L83.6786 80.137L94.293 76.3902L83.6786 86.3802L101.161 75.1413L83.6786 93.8723L107.405 76.3902L82.4297 99.4924L112.4 78.8881L82.4297 106.36L112.4 86.3802L91.1707 105.111L113.024 93.2479L99.2873 104.487L112.4 100.117L109.902 104.487",
    stroke: "#1B2F6C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M139.396 171.92H116V196.27H139.396V171.92Z",
    stroke: "#1B2F6C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M120.775 171.92L116.955 176.217L125.072 173.352L116.955 180.991L130.325 172.397L116.955 186.72L135.099 173.352L116 191.018L138.918 175.262L116 196.27L138.918 180.991L122.685 195.315L139.396 186.243L128.891 194.837L138.918 191.495L137.008 194.837",
    stroke: "#1B2F6C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8066 118.223H141.746",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1816 123.842L140.497 124.466",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M119.268 76.3899H138.623",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M119.268 83.8821H138.623",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M119.268 91.3755H138.623",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M119.268 98.8677H138.623",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M140.498 127.589H82.4316V155.685H140.498V127.589Z",
    stroke: "#1B2F6C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8075 133.208L89.9241 128.213L80.5586 142.573L96.1687 128.213L82.432 148.818L106.783 127.589L85.5543 152.563L111.777 128.213L91.7975 152.563L120.518 127.589L97.4176 155.061L126.139 128.213L104.285 153.812L133.631 127.589L111.153 155.061L140.498 127.589L119.27 154.436L139.249 136.954L126.139 153.188L139.249 144.446L136.677 148.627L134.255 152.563",
    stroke: "#1B2F6C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9297 163.177H138.625",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6797 170.046H101.162",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M151.111 56.4101L193.975 51.1462",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M144.244 87.0042H189.198",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0644 143.822L53.709 150.691",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M128.009 200.641C128.009 200.641 124.262 219.996 149.862 224.992",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M146.119 219.996L152.362 225.615L143.621 228.113",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M183.58 81.3857L193.57 87.629L184.829 91.3757",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M185.857 49.2727L196.472 50.5216L188.98 57.3906",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2082 144.446L45.5938 153.187L58.7046 153.812",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M220.418 81.3857H196.691V106.361H220.418V81.3857Z",
    fill: "#1B2F6C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M202.312 87.0044L216.049 87.6288",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M202.312 92L216.049 92.6245",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M202.312 96.9944L216.049 97.6188",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M182.653 115.047L159.09 117.825L162.014 142.627L185.577 139.849L182.653 115.047Z",
    fill: "#1B2F6C"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M165.336 122.747L179.051 121.758",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M165.92 127.708L179.635 126.719",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M166.506 132.669L180.221 131.681",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6528 157.501L36.0898 160.28L39.0143 185.081L62.5773 182.303L59.6528 157.501Z",
    fill: "#1B2F6C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M42.334 165.205L56.049 164.216",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9199 170.166L56.6349 169.177",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5059 175.126L57.2195 174.137",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M182.324 209.464L158.73 206.957L156.091 231.791L179.684 234.299L182.324 209.464Z",
    fill: "#1B2F6C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M163.736 213.131L177.331 215.202",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M163.209 218.097L176.802 220.169",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M162.68 223.064L176.273 225.136",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M355.033 252.84H22.3066V261.35H355.033V252.84Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M488.552 313.814V297.932H440.772V313.814C440.772 318.997 438.984 324.027 435.698 328.091L433.605 330.678H495.719L493.626 328.091C490.342 324.027 488.552 318.997 488.552 313.814Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M485.843 313.814V297.932H438.063V313.814C438.063 318.997 436.275 324.027 432.989 328.091L430.896 330.678H493.01L490.918 328.091C487.633 324.027 485.843 318.997 485.843 313.814Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M486.231 302.417H438.26V307.283H486.231V302.417Z",
    fill: "#263238"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M546.479 302.939H377.434C371.086 302.939 365.941 297.795 365.941 291.447V173.432C365.941 167.084 371.087 161.939 377.434 161.939H546.479C552.826 161.939 557.971 167.085 557.971 173.432V291.447C557.971 297.793 552.825 302.939 546.479 302.939Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M551.628 302.939H382.584C376.236 302.939 371.092 297.795 371.092 291.447V173.432C371.092 167.084 376.238 161.939 382.584 161.939H551.629C557.976 161.939 563.121 167.085 563.121 173.432V291.447C563.121 297.793 557.975 302.939 551.628 302.939Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M546.479 302.94H377.434C371.086 302.94 365.941 297.795 365.941 291.448V281.023H557.971V291.448C557.971 297.794 552.825 302.94 546.479 302.94Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M548.313 170.71H375.602V270.328H548.313V170.71Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M435.711 259.485H401.721C399.45 259.485 397.609 257.644 397.609 255.373V185.2C397.609 182.93 399.45 181.087 401.721 181.087H435.711C437.981 181.087 439.822 182.928 439.822 185.2V255.373C439.822 257.644 437.981 259.485 435.711 259.485Z",
    fill: "#263238"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M436.282 187.667H401.152V252.907H436.282V187.667Z",
    fill: "#1B2F6C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M482.584 188.762H450.787V192.051H482.584V188.762Z",
    fill: "#263238"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M466.137 195.89H451.334V211.24H466.137V195.89Z",
    fill: "#1B2F6C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M480.393 243.038H472.463V251.261H480.393V243.038Z",
    fill: "#1B2F6C"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M481.852 222.205H451.699V237.555H481.852V222.205Z",
    fill: "#1B2F6C"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M468.877 196.986H480.938",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M468.877 200.823H480.938",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M468.877 204.661H480.938",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M468.877 208.499H480.938",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M452.25 217.271H481.307",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M452.25 241.393H481.307",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M485.326 185.474H448.047V254.551H485.326V185.474Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M530.83 185.474H495.742V211.24H530.83V185.474Z",
    fill: "#BFBFBF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M530.83 185.474H495.742V190.956H530.83V185.474Z",
    fill: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M507.633 194.953H498.463V203.828H507.633V194.953Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M525.975 194.953H516.805V203.828H525.975V194.953Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M527.456 188.593C527.456 189.329 526.86 189.925 526.125 189.925C525.389 189.925 524.793 189.329 524.793 188.593C524.793 187.858 525.389 187.262 526.125 187.262C526.86 187.262 527.456 187.858 527.456 188.593Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M519.763 189.925C520.499 189.925 521.095 189.329 521.095 188.593C521.095 187.858 520.499 187.262 519.763 187.262C519.028 187.262 518.432 187.858 518.432 188.593C518.432 189.329 519.028 189.925 519.763 189.925Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M528.031 225.207H501.164V244.936H528.031V225.207Z",
    fill: "#BFBFBF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M528.031 225.207H501.164V229.405H528.031V225.207Z",
    fill: "#263238"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M525.446 227.597C525.446 228.16 524.99 228.617 524.426 228.617C523.863 228.617 523.406 228.16 523.406 227.597C523.406 227.033 523.863 226.577 524.426 226.577C524.99 226.577 525.446 227.033 525.446 227.597Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M520.575 227.597C520.575 228.16 520.119 228.617 519.555 228.617C518.992 228.617 518.535 228.16 518.535 227.597C518.535 227.033 518.992 226.577 519.555 226.577C520.119 226.577 520.575 227.033 520.575 227.597Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M392.571 175.937H381.283V264.435H392.571V175.937Z",
    fill: "#BFBFBF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M392.571 175.937H381.283V180.001H392.571V175.937Z",
    fill: "#263238"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M389.41 182.71H383.992V189.032H389.41V182.71Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M389.41 193.095H383.992V199.417H389.41V193.095Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M389.41 203.481H383.992V209.803H389.41V203.481Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M389.41 213.865H383.992V220.187H389.41V213.865Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M389.41 224.25H383.992V230.572H389.41V224.25Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M389.41 234.636H383.992V240.958H389.41V234.636Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M389.41 245.02H383.992V251.342H389.41V245.02Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M389.41 255.406H383.992V261.728H389.41V255.406Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M543.381 175.035H399.797V178.648H543.381V175.035Z",
    fill: "#BFBFBF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M543.381 262.63H399.797V266.243H543.381V262.63Z",
    fill: "#BFBFBF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M493.024 330.677H430.896V333.514H493.024V330.677Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M533.63 328.362H389.406V333.514H533.63V328.362Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M260.18 529.282H254.309L251.375 349.576H263.114L260.18 529.282Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M260.181 529.282H257.59L257.934 349.576H263.115L260.181 529.282Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M343.791 529.282H337.922L334.986 349.576H346.726L343.791 529.282Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M343.791 529.282H341.201L341.545 349.576H346.726L343.791 529.282Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M313.848 529.282H307.977L305.043 349.576H316.782L313.848 529.282Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M313.849 529.282H311.258L311.602 349.576H316.783L313.849 529.282Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M370.348 529.282H364.478L361.543 349.576H373.283L370.348 529.282Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M370.348 529.282H367.758L368.102 349.576H373.283L370.348 529.282Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M374.757 352.314H282.666V464.744H374.757V352.314Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M349.335 352.314H257.244V464.744H349.335V352.314Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M535.318 529.282H529.448L526.514 349.576H538.252L535.318 529.282Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M535.32 529.282H532.729L533.073 349.576H538.254L535.32 529.282Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M588.992 529.282H583.121L580.188 349.576H591.926L588.992 529.282Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M588.992 529.282H586.4L586.744 349.576H591.926L588.992 529.282Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M595.63 342.797H243.633V355.159H595.63V342.797Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M595.63 342.797H243.633V348.978H595.63V342.797Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M595.628 342.797H543.672V355.159H595.628V342.797Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M607 332.864H234.078V345.226H607V332.864Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M606.999 332.864H555.043V345.226H606.999V332.864Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M343.695 363.122H263.098V402.404H343.695V363.122Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M312.199 378.699H294.59V384.795H312.199V378.699Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M343.695 412.563H263.098V451.846H343.695V412.563Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M312.199 428.141H294.59V434.236H312.199V428.141Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M467.772 424.258H491.854V375.826H467.772V424.258Z",
    fill: "#263238"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M473.793 474.141H485.834V407.056H473.793V474.141Z",
    fill: "#263238"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M484.709 468.98C484.709 468.98 494.825 480.459 520.831 484.462C534.57 486.576 548.868 489.204 561.281 495.775C569.265 500.001 585.153 509.249 585.153 519.816C585.153 525.043 580.914 529.282 575.687 529.282C570.46 529.282 566.221 525.043 566.221 519.816C566.221 517.317 567.209 515.06 568.791 513.368C567.471 511.221 558.86 498.273 540.736 494.333C520.954 490.032 506.514 491.783 478.688 473.281L484.709 468.98Z",
    fill: "#263238"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M476.102 468.98C476.102 468.98 465.986 480.459 439.98 484.462C426.241 486.576 411.943 489.204 399.53 495.775C391.546 500.001 375.658 509.249 375.658 519.816C375.658 525.043 379.897 529.282 385.124 529.282C390.351 529.282 394.59 525.043 394.59 519.816C394.59 517.317 393.602 515.06 392.02 513.368C393.339 511.221 401.95 498.273 420.075 494.333C439.855 490.032 454.296 491.783 482.123 473.281L476.102 468.98Z",
    fill: "#263238"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M475.688 511.516H484.795C485.285 511.516 485.682 511.913 485.682 512.403V528.394C485.682 528.884 485.284 529.281 484.795 529.281H475.688C475.198 529.281 474.801 528.884 474.801 528.394V512.404C474.801 511.914 475.198 511.516 475.688 511.516Z",
    fill: "#263238"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M477.661 529.282H482.822V470.583H477.661V529.282Z",
    fill: "#263238"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M538.135 235.966C535.355 251.2 533.211 267.862 532.706 284.54C532.325 297.106 532.115 307.878 531.929 317.379C531.352 346.884 531.033 363.253 526.385 367.659C525.789 368.06 521.949 370.436 513.892 371.106C511.642 371.293 504.501 371.398 494.775 371.444C463.929 371.351 431.511 371.097 430.994 371.093H429.112C429.029 371.163 428.967 371.238 428.89 371.309C410.368 371.208 405.597 371.095 405.255 371.093H403.374C399.489 374.466 401.811 378.802 405.185 378.833C407.725 378.856 451.87 379.216 482.058 379.216C487.405 379.216 492.427 379.205 496.889 379.178C504.226 379.201 511.225 379.216 517.277 379.216C533.089 379.216 546.184 379.119 549.751 378.821C560.924 377.891 565.933 374.113 566.468 373.688C573.916 367.071 574.2 352.568 574.886 317.529C575.071 308.047 575.28 297.298 575.66 284.775C576.168 267.998 578.378 251.221 581.215 235.965H538.135V235.966Z",
    fill: "#263238"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M298.656 488.872L301.704 504.788C301.704 504.788 298.994 510.545 288.497 515.286C277.999 520.027 272.919 522.059 272.919 523.414C272.919 524.768 272.242 527.816 274.951 528.832C277.66 529.848 335.229 528.832 335.229 528.832C335.229 528.832 338.277 527.477 338.277 521.043C338.277 514.609 335.568 502.756 335.568 500.047C335.568 497.338 333.661 490.81 333.661 489.895C333.661 488.979 310.508 490.227 310.508 490.227C310.508 490.227 303.735 483.792 298.656 488.872Z",
    fill: "#EF7F1A"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M310.506 490.227C310.506 490.227 312.199 505.465 313.215 506.481C314.231 507.497 335.565 507.497 335.565 507.497",
    fill: "#EF7F1A"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M340.982 297.994C340.982 297.994 322.204 361.197 319.915 369.9C317.624 378.601 330.907 455.087 330.907 456.461C330.907 457.834 332.738 461.956 332.738 466.537C332.738 471.119 330.907 472.492 331.823 473.866C332.738 475.239 335.945 478.445 335.487 481.194C335.029 483.942 334.571 484.858 332.738 486.689C330.907 488.522 329.074 488.98 329.074 488.98H318.082C318.082 488.98 315.333 468.37 308.005 413.869C300.677 359.368 312.585 328.224 314.876 318.148C317.166 308.073 321.746 299.37 321.746 299.37L340.982 297.994Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M283.076 488.872L286.124 504.788C286.124 504.788 283.414 510.545 272.916 515.286C262.419 520.027 257.339 522.059 257.339 523.414C257.339 524.768 256.662 527.816 259.371 528.832C262.08 529.848 319.649 528.832 319.649 528.832C319.649 528.832 322.697 527.477 322.697 521.043C322.697 514.609 319.988 502.756 319.988 500.047C319.988 497.338 318.081 490.81 318.081 489.895C318.081 488.979 294.928 490.227 294.928 490.227C294.928 490.227 288.155 483.792 283.076 488.872Z",
    fill: "#EF7F1A"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M294.926 490.227C294.926 490.227 296.619 505.465 297.635 506.481C298.651 507.497 319.985 507.497 319.985 507.497",
    fill: "#EF7F1A"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M265.414 297.994C265.414 297.994 264.956 337.84 267.246 354.785C269.536 371.731 278.238 411.119 279.612 432.645C280.985 454.17 283.276 464.247 283.276 464.247C283.276 464.247 280.069 466.995 280.069 469.742C280.069 472.491 281.902 472.491 281.443 476.613C280.985 480.735 279.154 482.108 280.527 483.941C281.901 485.772 282.818 489.437 287.398 490.352C291.977 491.268 313.503 490.81 318.084 489.894C322.664 488.979 324.954 484.399 324.954 480.735C324.954 477.071 323.581 474.322 323.581 470.2C323.581 466.078 325.87 462.414 325.87 459.666C325.87 456.917 324.954 455.544 324.954 452.795C324.954 450.047 319.001 406.08 319.001 396.919C319.001 387.76 318.543 356.615 319.917 348.829C321.29 341.043 328.161 303.946 328.161 303.946L265.414 297.994Z",
    fill: "#1B2F6C",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M294.439 311.434C294.439 311.434 302.251 314.312 311.297 314.723C320.343 315.134 324.454 315.957 324.454 315.957L326.921 304.444L294.439 311.434Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M289.418 313.403C289.418 313.403 291.665 376.34 296.161 397.318C300.657 418.298 306.651 452.762 305.153 457.258C303.655 461.754 301.406 472.244 301.406 472.244C301.406 472.244 309.647 470.746 309.647 475.24C309.647 479.736 297.659 482.732 300.655 484.981C303.653 487.228 306.628 489.704 306.628 489.704",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M316.04 474.246C316.04 474.246 291.17 478.279 298.228 479.624C305.285 480.968 318.729 479.288 319.401 477.607C320.074 475.926 318.057 473.909 316.04 474.246Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M206.26 39.1342L205.574 67.2524L232.093 67.0248L232.322 38.9053L206.26 39.1342Z",
    fill: "#1B2F6C"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M236.436 91.0274C236.436 91.0274 230.721 85.3124 228.206 80.054C225.692 74.7955 222.033 71.596 222.033 67.9373C222.033 64.28 223.633 55.8207 222.948 52.3923C222.262 48.9639 222.948 41.8768 225.234 41.8768C227.521 41.8768 229.12 43.9344 228.664 46.2209C228.206 48.5074 230.036 56.5088 230.036 56.5088C230.036 56.5088 231.865 41.1914 232.094 40.277C232.323 39.3627 235.523 39.3627 236.894 40.0481C238.266 40.7335 239.866 40.5059 239.866 43.4779C239.866 46.4498 239.181 49.8796 239.181 50.565C239.181 51.2504 245.582 54.9091 245.81 57.6521C246.039 60.3951 245.352 67.0257 243.752 69.7687C242.153 72.5117 241.238 74.3404 241.009 75.2547C240.78 76.1691 247.182 85.7703 247.182 85.7703L236.436 91.0274Z",
    fill: "#F7BB8B"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M247.094 81.3613L231.521 93.2694C231.521 93.2694 258.085 148.23 259.002 150.061C259.917 151.894 279.154 163.8 279.154 163.8L308.007 128.076C308.007 128.076 271.825 116.626 270.91 115.253C269.994 113.879 247.094 81.3613 247.094 81.3613Z",
    fill: "#EF7F1A",
    stroke: "#EF7F1A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M265.468 283.315L264.113 304.65C264.113 304.65 281.723 312.1 300.687 311.761C319.651 311.423 345.049 303.972 345.049 303.972L348.774 282.977C348.774 282.977 303.057 286.702 289.173 285.347C275.288 283.992 265.468 283.315 265.468 283.315Z",
    fill: "#EF7F1A"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M251.924 276.543L250.908 282.638C250.908 282.638 265.257 290.47 296.964 293.475C329.135 296.523 354.871 287.379 354.871 287.379L355.21 276.881C355.21 276.881 330.151 283.316 303.736 282.977C277.322 282.638 251.924 276.543 251.924 276.543Z",
    fill: "#263238",
    stroke: "#EF7F1A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M277.66 150.568C277.66 150.568 266.485 170.209 262.76 185.448C259.035 200.687 251.585 271.124 250.569 275.188C249.553 279.252 273.258 287.379 288.835 287.718C304.413 288.057 339.293 288.734 345.389 286.363C351.484 283.993 357.241 280.606 357.241 276.881C357.241 273.156 357.58 259.272 357.58 248.097C357.58 236.922 354.193 177.998 351.146 164.452C348.098 150.906 346.066 141.424 345.05 139.731C344.034 138.038 336.584 129.91 321.345 130.926C306.106 131.942 293.238 137.699 287.481 141.086C281.724 144.472 277.66 150.568 277.66 150.568Z",
    fill: "#EF7F1A",
    stroke: "#EF7F1A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M175.525 172.461C175.525 172.461 170.03 174.752 169.572 180.247C169.114 185.743 179.189 191.24 185.144 199.484C191.097 207.728 198.883 216.429 198.883 216.429L210.791 232.917L224.989 221.009L188.349 178.416C188.349 178.416 190.18 174.294 187.891 172.92C185.602 171.546 179.647 170.63 175.525 172.461Z",
    fill: "white",
    stroke: "#EF7F1A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M176.443 185.286L217.663 171.547C217.663 171.547 220.411 182.997 232.777 194.905C245.143 206.813 256.593 214.599 256.593 214.599L219.496 235.667L176.443 185.286Z",
    fill: "white",
    stroke: "#EF7F1A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M176.441 185.286C176.441 185.286 179.19 182.538 179.647 177.958C180.105 173.378 175.525 172.463 175.525 172.463L216.287 160.555C216.287 160.555 224.073 163.303 217.661 171.547L176.441 185.286Z",
    fill: "white",
    stroke: "#EF7F1A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M231.065 228.836C231.065 228.836 221.905 227.462 221.448 224.714C220.99 221.965 219.157 216.012 217.326 213.721C215.493 211.431 206.791 206.851 204.044 203.646C201.296 200.44 199.464 195.86 197.633 196.318C195.8 196.776 193.053 198.609 193.969 200.44C194.884 202.271 199.006 210.057 199.006 210.057L199.922 213.264C199.922 213.264 191.678 211.89 190.305 211.432C188.931 210.974 187.098 211.89 187.098 214.181C187.098 216.471 185.266 216.471 187.556 217.845C189.847 219.218 192.594 221.051 192.594 221.051C192.594 221.051 195.8 228.379 196.716 229.753C197.632 231.126 204.96 234.333 206.333 235.248C207.707 236.164 215.035 238.455 218.699 239.37C222.363 240.286 230.607 243.492 230.607 243.492L232.898 232.958L231.065 228.836Z",
    fill: "#F7BB8B",
    stroke: "#EF7F1A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M328.158 165.632C328.158 165.632 327.243 204.562 327.243 206.393C327.243 208.225 328.616 245.782 324.494 248.987C320.372 252.193 300.22 256.315 270.909 255.399C241.597 254.483 228.773 248.071 228.773 248.071L231.064 228.835L286.94 224.713C286.94 224.713 280.987 182.119 281.902 167.463C282.818 152.807 294.726 145.021 294.726 145.021",
    fill: "#EF7F1A"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M328.158 165.632C328.158 165.632 327.243 204.562 327.243 206.393C327.243 208.225 328.616 245.782 324.494 248.987C320.372 252.193 300.22 256.315 270.909 255.399C241.597 254.483 228.773 248.071 228.773 248.071L231.064 228.835L286.94 224.713C286.94 224.713 280.987 182.119 281.902 167.463C282.818 152.807 294.726 145.021 294.726 145.021",
    stroke: "#EF7F1A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M266.492 257.103C266.492 257.103 321.959 259.05 324.88 252.238C327.799 245.425 327.799 178.281 327.799 178.281",
    stroke: "#1B2F6C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M290.82 152.98C290.82 152.98 279.142 165.63 281.089 182.174C283.035 198.717 286.939 224.714 286.939 224.714L265.52 225.964",
    stroke: "#1B2F6C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M267.202 47.2165C267.202 47.2165 259.527 60.5008 261.002 62.2726C262.479 64.0443 261.298 67.2912 261.298 67.2912C261.298 67.2912 253.623 73.1958 254.212 75.2615C254.803 77.3273 261.002 82.9365 261.002 82.9365C261.002 82.9365 262.184 98.8785 263.659 100.354C265.135 101.83 275.173 103.601 277.238 103.896C279.305 104.191 280.485 104.782 280.485 104.782L286.39 136.664L319.453 106.847L314.139 92.6772C314.139 92.6772 311.188 73.7837 311.483 64.9275C311.778 56.0713 296.427 45.4434 287.276 42.7871C278.126 40.1321 267.202 47.2165 267.202 47.2165Z",
    fill: "#F7BB8B"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M273.401 29.209C273.401 29.209 265.726 21.2387 256.574 27.4372C247.423 33.6371 250.079 43.6731 258.346 47.2167C266.612 50.7589 276.354 48.1026 273.107 51.6448C269.86 55.187 268.974 62.8633 273.993 64.3384C279.011 65.8149 278.125 71.4228 278.125 73.7852C278.125 76.1476 282.258 75.8509 283.144 73.7852C284.03 71.7181 286.391 66.1102 292 68.4712C297.61 70.8322 297.314 83.8226 295.247 87.0695C293.18 90.3164 291.114 90.0211 291.114 90.0211C291.114 90.0211 294.361 91.2023 292.296 95.0398C290.23 98.8773 290.23 98.8773 290.23 98.8773C290.23 98.8773 294.953 104.487 306.761 102.419C318.569 100.352 321.227 95.0398 319.455 90.6117C317.683 86.1836 313.55 85.593 317.978 79.0992C322.406 72.604 333.338 64.929 332.444 50.1683C331.853 40.4262 308.827 31.2747 308.827 31.2747C308.827 31.2747 314.141 22.4185 302.036 16.8093C289.933 11.2 276.058 17.6952 276.944 23.5984C277.829 29.5043 273.401 29.209 273.401 29.209Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M260.913 61.2038C260.913 61.2038 257.165 60.2055 256.87 61.9773C256.574 63.7491 256.87 72.6053 256.87 72.6053C256.87 72.6053 259.231 74.0817 261.298 73.4912C263.363 72.9006 262.184 65.5209 262.184 65.5209",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M284.324 71.1288L257.135 66.633L257.163 64.929L284.324 71.1288Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M323.289 97.6977C323.289 97.6977 308.233 108.621 297.901 119.838C287.569 131.057 275.17 143.455 274.58 147.293C273.989 151.13 275.17 157.035 281.075 150.835C286.979 144.635 297.901 136.369 306.168 135.779C314.434 135.188 327.127 139.321 333.623 140.207C340.118 141.093 344.251 142.863 346.612 139.321C348.973 135.779 342.774 127.808 342.774 123.674C342.774 119.54 343.66 112.456 340.708 107.437C337.754 102.421 328.307 96.2212 323.289 97.6977Z",
    fill: "#F47300",
    stroke: "#EF7F1A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M342.582 112.324C342.582 112.324 340.874 118.02 339.164 120.583C337.456 123.146 313.25 127.987 313.25 127.987C313.25 127.987 333.184 126.848 336.886 126.848C340.588 126.848 344.859 130.266 344.859 130.266L342.865 124.856C342.865 124.856 343.721 114.887 342.582 112.324Z",
    fill: "#263238",
    stroke: "#EF7F1A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppdevbanner2);
export default __webpack_public_path__ + "static/media/appdevbanner2.fab8afc5c4a1e38c0da0c2883a3e8dae.svg";
export { ForwardRef as ReactComponent };